import { StaffDesignBoundary } from "./components/StaffDesignBoundary";
import { AuthGate } from "./components/Authentication";
import { IntegratedShell } from "./components/IntegratedShell";

export default function IntegratedApp() {
  return (
    <AuthGate>
      {(session, logout, loggingOut) => (
        <StaffDesignBoundary><IntegratedShell
          session={session}
          loggingOut={loggingOut}
          onLogout={logout}
        /></StaffDesignBoundary>
      )}
    </AuthGate>
  );
}
